export default {
  title: 'Wniosek',
  type: 'object',
  properties: {
    content: {
      title: 'schema.offer.content',
      type: 'string',
      fieldRequired: true,
      maxLength: 500
    },
    clubId: {
      title: 'schema.offer.clubId',
      type: 'number',
      fieldRequired: true
    },
    profileId: {
      title: 'schema.offer.profileId',
      type: 'number',
      fieldRequired: true
    },
    type: {
      title: 'schema.offer.type',
      type: 'string',
      fieldRequired: true
    }
  }
};
